import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

import notification from "@/store/modules/notification";
import loading from "@/store/modules/loading";
import authentication from "@/store/modules/authentication";
import authorization from "@/store/modules/authorization";
import actionCable from "@/store/modules/action_cable";
import inactivity from "@/store/modules/inactivity";
import form from "@/store/modules/form";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: "eaglesoft",
  modules: ["authentication"],
});

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    notification,
    loading,
    authentication,
    authorization,
    actionCable,
    inactivity,
    form,
  },
  plugins: [vuexLocal.plugin],
});
